import { render, staticRenderFns } from "./CombinationsProductTable.vue?vue&type=template&id=31673d6d&scoped=true"
import script from "./CombinationsProductTable.vue?vue&type=script&lang=ts"
export * from "./CombinationsProductTable.vue?vue&type=script&lang=ts"
import style0 from "./CombinationsProductTable.vue?vue&type=style&index=0&id=31673d6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31673d6d",
  null
  
)

export default component.exports